"use client";

import { BadgeCheck, ShieldCheck } from "lucide-react";
import { motion } from "framer-motion";
const trustPoints = ["Partner-approved imagery", "Official rates and offers only", "Visitor rules clearly communicated"];
export default function ReassuranceBand() {
  return <section id="reassurance-band" className="w-full overflow-hidden bg-[#073F31] ![padding:36px_32px_48px_32px] !h-[200px]" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
      <div className="grid w-full max-w-[1480px] items-center gap-8 ![margin:-20px_164.667px_0px_164.667px] lg:grid-cols-[96px_minmax(0,1.25fr)_minmax(350px,0.75fr)] lg:gap-10">
        {/* Left premium emblem */}
        <div className="flex justify-center lg:justify-start">
          <div className={["relative flex size-[88px] items-center justify-center rounded-full", "border border-[#D8C69B]/45", "bg-[radial-gradient(circle_at_30%_30%,rgba(191,255,0,0.18),rgba(191,255,0,0.02)_45%,transparent_70%)]", "shadow-[0_14px_30px_rgba(0,0,0,0.16)]"].join(" ")}>
            <div className={["flex size-[62px] items-center justify-center rounded-full", "border border-[#D8C69B]/55 bg-[#0C4B3A]"].join(" ")}>
              <ShieldCheck className="lucide lucide-shield-check lucide lucide-shield-check lucide lucide-shield-check lucide lucide-shield-check size-[28px] text-[#D8C69B] !w-[40px] !h-[40px]" strokeWidth={1.65} aria-hidden="true" />
            </div>
          </div>
        </div>

        {/* Main copy */}
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55,
        ease: "easeOut"
      }} className="text-center lg:text-left">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] !text-[rgba(154,121,58,0.01)]"><span className="!text-xs" contenteditable="false" style={{}}><span className="text-secondary" contenteditable="false" style={{}}><span className="!text-[rgba(163,139,92,1)]" contenteditable="false" style={{}}><span className="!text-[rgba(190,171,136,1)] !font-extrabold"><span className="!text-[rgba(190,171,136,1)] !m-0">Partner Confidenc</span>e</span></span></span></span></p>

          <h2 className="text-[34px] font-medium leading-[1.08] text-[#FFFDF7] ![margin:8px_0px_0px_0px] md:text-[40px]" style={{
          fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
        }}>
            Your brand, rates and standards remain under your control.
          </h2>

          <p className="mt-4 max-w-[800px] text-[15px] leading-[1.75] !w-[800px] text-secondary !font-semibold md:text-[16px]"><span className="text-secondary">TeeListClub helps your course appear at its best while respecting your brand, pricing and visitor policies.</span></p>
        </motion.div>

        {/* Trust points */}
      <motion.div initial={{
        opacity: 0,
        x: 18
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.55,
        delay: 0.08,
        ease: "easeOut"
      }} className="lg:border-l lg:border-[#D8C69B]/28 lg:pl-10 xl:pl-12">
  {trustPoints.map((item, index) => <div key={item} className="flex items-center gap-4 py-4 !h-[48px] !justify-start">
      <BadgeCheck className="lucide lucide-badge-check lucide lucide-badge-check size-[20px] shrink-0 text-[#D8BD67] !w-[40px] !h-[40px]" strokeWidth={1.8} aria-hidden="true" />

      <span className="leading-[1.45] text-[#FFFDF7] !text-lg !not-italic !font-medium !font-sans">
        {item}
      </span>
    </div>)}
      </motion.div>
      </div>
    </section>;
}